import React from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import styles from "./Intro.module.sass";
import ScrollParallax from "../../../components/ScrollParallax";

const PresentationServices = ({ scrollToRef }) => {
  return (
    <div className={styles.section} ref={scrollToRef}>
      <div className={cn("container", styles.container)}>
        <div className={styles.gallery}>
          {/* Image principale au centre */}
          <div className={styles.mainImage}>
            <ScrollParallax animateIn="fadeInUp" offset={200}>
              <img
                src="/images/content/illusp21.svg"
                alt="Interface principale"
                className={styles.centralImage}
              />
            </ScrollParallax>
          </div>
          
          {/* SVG flottants autour */}
          <ScrollParallax 
            className={styles.floatingElement} 
            animateIn="fadeInLeft" 
            offset={300}
            style={{
              position: 'absolute',
              top: '8%',
              left: '2%',
              zIndex: 2
            }}
          >
            <img
              src="/images/content/illusp22.svg"
              alt="Élément flottant 1"
              className={styles.floatingSmall}
            />
          </ScrollParallax>
          
          <ScrollParallax 
            className={styles.floatingElement} 
            animateIn="fadeInRight" 
            offset={400}
            style={{
              position: 'absolute',
              top: '15%',
              right: '2%',
              zIndex: 3
            }}
          >
            <img
              src="/images/content/illusp23.svg"
              alt="Élément flottant 2"
              className={styles.floatingMedium}
            />
          </ScrollParallax>
          
        </div>
        <div className={styles.wrap}>
          <h2 className={cn("h1", styles.title)}>
            Facilitez le suivi pédagogique.
          </h2>
          <div className={styles.text}>
            Optimisez le suivi pédagogique de vos apprentis grâce à nos outils avancés : émargement digital, rapports automatiques et tableaux de bord en temps réel. Centralisez toutes vos données pédagogiques pour une gestion simplifiée et efficace.
          </div>
          <Link className={cn("button", styles.button)} to="/emargement-assiduite">
            En savoir plus
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PresentationServices;
